import React, { useState } from 'react';
import { createPortal } from 'react-dom';
import { useWidgetFichaje } from '../../hooks/useWidgetFichaje';
import { Modal } from './ui';

const horaActual = () => new Date().toLocaleTimeString('es-ES', { hour: '2-digit', minute: '2-digit' });

export default function WidgetFichaje({ onEstadoCambiado }) {
    // LÓGICA AISLADA (SRP)
    const { isActivo, segundos, procesando, handleFichar, formatTime } = useWidgetFichaje(onEstadoCambiado);
    // Confirmación antes de fichar: evita empezar o terminar la jornada sin querer
    const [confirmar, setConfirmar] = useState(null); // 'entrada' | 'salida' | null

    const aceptar = async () => {
        const tipo = confirmar;
        setConfirmar(null);
        await handleFichar(tipo);
    };

    // VISTA PURA
    return (
        <>
            <div className={`flex items-center gap-2 sm:gap-3 px-2 sm:px-3 py-1.5 rounded-xl border transition-all ${isActivo ? 'bg-emerald-50 border-emerald-200' : 'bg-white border-slate-200'}`}>
                <div className="flex flex-col items-end min-w-[50px] sm:min-w-[70px]">
                    <span className={`text-[8px] sm:text-[10px] font-black uppercase tracking-widest flex items-center gap-1 ${isActivo ? 'text-emerald-600' : 'text-slate-400'}`}>
                        {isActivo && <span className="w-1.5 h-1.5 rounded-full bg-emerald-500 animate-pulse"></span>}
                        <span className="hidden sm:inline">{isActivo ? 'En Turno' : 'Pausado'}</span>
                    </span>
                    <span className={`text-xs sm:text-sm font-bold font-mono ${isActivo ? 'text-emerald-900' : 'text-slate-600'}`}>
                        {formatTime(segundos)}
                    </span>
                </div>
                <div className="w-px h-6 sm:h-8 bg-slate-200 mx-0.5 sm:mx-1"></div>
                <button
                    onClick={() => setConfirmar(isActivo ? 'salida' : 'entrada')} disabled={procesando}
                    className={`flex items-center justify-center w-7 h-7 sm:w-8 sm:h-8 rounded-lg font-black transition-colors outline-none focus:ring-2 ${isActivo ? 'bg-rose-100 text-rose-600 hover:bg-rose-500 hover:text-white focus:ring-rose-200' : 'bg-emerald-100 text-emerald-600 hover:bg-emerald-500 hover:text-white focus:ring-emerald-200'}`}
                    title={isActivo ? "Fichar Salida" : "Fichar Entrada"}
                >
                    {procesando ? (
                        <div className="w-3 h-3 border-2 border-current border-t-transparent rounded-full animate-spin"></div>
                    ) : isActivo ? '■' : '▶'}
                </button>
            </div>

            {/* Fuera de la cabecera (su desenfoque descolocaría la ventana): portal a body */}
            {createPortal(<Modal
                open={Boolean(confirmar)}
                onClose={() => setConfirmar(null)}
                titulo={confirmar === 'salida' ? '¿Terminar la jornada?' : '¿Empezar la jornada?'}
                size="sm"
            >
                <p className="text-sm font-semibold text-slate-600 leading-relaxed">
                    {confirmar === 'salida'
                        ? <>Se registrará tu salida a las <strong className="text-slate-900">{horaActual()}</strong>. Llevas <strong className="text-slate-900">{formatTime(segundos)}</strong> de jornada.</>
                        : <>Se registrará tu entrada a las <strong className="text-slate-900">{horaActual()}</strong> y empezará a contar tu jornada.</>}
                </p>
                <div className="flex justify-end gap-3 mt-6">
                    <button type="button" onClick={() => setConfirmar(null)}
                            className="px-5 py-2.5 rounded-xl text-sm font-bold text-slate-600 hover:bg-slate-100">
                        Cancelar
                    </button>
                    <button type="button" onClick={aceptar}
                            className={`px-5 py-2.5 rounded-xl text-sm font-black text-white ${confirmar === 'salida' ? 'bg-rose-600 hover:bg-rose-700' : 'bg-emerald-600 hover:bg-emerald-700'}`}>
                        {confirmar === 'salida' ? 'Sí, terminar jornada' : 'Sí, empezar jornada'}
                    </button>
                </div>
            </Modal>, document.body)}
        </>
    );
}
